import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./dropdown-menu";
import { Edit2, Eye, MoreVertical, Trash2 } from "lucide-react";
import { cn } from "./utils";

interface ActionMenuItem {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  variant?: 'default' | 'destructive';
}

interface ActionMenuProps {
  items: ActionMenuItem[];
  align?: 'start' | 'center' | 'end';
  className?: string;
  triggerClassName?: string;
}

export function ActionMenu({
  items,
  align = 'end',
  className = 'w-40',
  triggerClassName = ''
}: ActionMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className={cn(
            "p-2 text-slate-400 hover:text-white hover:bg-white/10 rounded-lg transition-colors",
            triggerClassName
          )}
        >
          <MoreVertical className="w-4 h-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align={align}
        className={cn("bg-slate-800 border-slate-700", className)}
      >
        {items.map((item, index) => (
          <DropdownMenuItem
            key={index}
            className={cn(
              "flex items-center gap-2 text-sm cursor-pointer",
              item.variant === 'destructive'
                ? "text-red-400 hover:bg-red-500/10"
                : "text-slate-300 hover:bg-slate-700"
            )}
            onSelect={item.onClick}
          >
            {item.icon}
            <span>{item.label}</span>
          </DropdownMenuItem>

    //         { item.icon }
    //       < span > { item.label }</span>
    // </DropdownMenuItem>
  ))
}
      </DropdownMenuContent >
    </DropdownMenu >
  );
}

// Pre-configured action menu for common CRUD operations
export function CrudActions({
  onView,
  onEdit,
  onDelete,
  viewLabel = 'View',
  editLabel = 'Edit',
  deleteLabel = 'Delete',
  className,
  triggerClassName,
}: {
  onView?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  viewLabel?: string;
  editLabel?: string;
  deleteLabel?: string;
  className?: string;
  triggerClassName?: string;
}) {
  const items: ActionMenuItem[] = [];

  if (onView) {
    items.push({
      label: viewLabel,
      icon: <Eye className="w-4 h-4" />,
      onClick: onView,
    });
  }

  if (onEdit) {
    items.push({
      label: editLabel,
      icon: <Edit2 className="w-4 h-4" />,
      onClick: onEdit,
    });
  }

  if (onDelete) {
    items.push({
      label: deleteLabel,
      icon: <Trash2 className="w-4 h-4" />,
      onClick: onDelete,
      variant: 'destructive',
    });
  }

  return (
    <ActionMenu
      items={items}
      className={className}
      triggerClassName={triggerClassName}
    />
  );
}
